import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Select,
  MenuItem,
  Grid,
  InputLabel,
  TextField,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import _ from "lodash";
import Utils from "../../utils/utils";

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  form: {
    paddingTop: "40px",
    marginLeft: -15,
  },
  button: {
    color: "blue",
    background: "#e7f103",
    "&:hover": { color: "white", background: "#0f70b7" },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonClear: {
    color: "#0366D6",
    "&:hover": { background: "transparent" },
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
});

const ChargesSearch = ({
  dataFilter,
  currentData,
  stateEdit,
  refresPaginator,
}) => {
  const classes = useStyles2();

  const [stateInitial, setStateInitial] = useState({
    denomination: "",
    status: "",
  });

  const defaultValues = {
    denomination: "",
    status: "",
  };
  const schema = yup.object().shape({
    denomination: yup.string(),
    status: yup.string(),
  });

  const { register, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const handleOnChange = (e) => {
    const { value, name } = e.target;
    setStateInitial({ ...stateInitial, [name]: value });
  };

  const clearBtn = () => {
    setStateInitial(defaultValues);
    dataFilter([...currentData]);
  };
  const { path } = useRouteMatch();

  const onSubmit = (data) => {
    const newData = { ...data, status: stateInitial.status };
    if (!newData.status && newData.denomination !== "") {
      const filterData = Utils.arrayFilter(currentData, newData);
      dataFilter([...filterData]);
    } else if (newData.denomination === "" && newData.status) {
      const response = _.filter(currentData, { status: newData.status });
      dataFilter(response);
    }else if(newData?.denomination === "" && newData?.status === ""){
      dataFilter(currentData);
    } else {
      const response = _.filter(
        currentData,
        (x) =>
          x?.denomination
            ?.toLowerCase()
            ?.includes(newData?.denomination?.toLowerCase()) &&
          x?.status?.toLowerCase() === newData?.status?.toLowerCase()
      );
      dataFilter(response);
    }
    refresPaginator();
  };

  return (
    <div>
      <Card
        className={classes.card}
        elevation={0}
        style={{ background: "#e0f2f7" }}
      >
        <CardContent>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={classes.form}
            autocomplete="off"
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6} lg={3}>
                <FormControl
                  fullWidth
                  size="small"
                  shrink={true}
                  notched={true}
                >
                  <TextField
                    fullWidth
                    native
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    className={classes.dropdown}
                    onChange={handleOnChange}
                    value={stateInitial.denomination}
                    inputRef={register}
                    type="text"
                    label="Nombre"
                    name="denomination"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel
                    htmlFor="outlined-select-estado"
                    shrink={true}
                    size="small"
                  >
                    Estado
                  </InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    inputRef={register}
                    className={classes.dropdown}
                    label="Estado"
                    notched={true}
                    value={stateInitial.status}
                    name="status"
                    onChange={handleOnChange}
                    inputProps={{
                      name: "status",
                      id: "outlined-select-estado",
                    }}
                  >
                    <MenuItem
                      className={classes.menuItem}
                      key="Activo"
                      value="Activo"
                    >
                      Activo
                    </MenuItem>
                    <MenuItem
                      className={classes.menuItem}
                      key="Inactivo"
                      value="Inactivo"
                    >
                      Inactivo
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Button
                  variant="contained"
                  className={classes.buttonSearch}
                  type="submit"
                >
                  Buscar
                </Button>
                &nbsp;&nbsp;
                <Button variant="contained" className={classes.buttonSearch} onClick={clearBtn}>
                  Limpiar
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default withRouter(ChargesSearch);
